import { Component } from '@angular/core';

@Component({
  selector: 'empty-cell',
  template: ``,
  standalone: false,
})
export class EmptyCellComponent {}
